import { Factory, Truck, Wrench, TrendingUp } from "lucide-react";

const AboutSection = () => {
  const features = [
    {
      icon: Factory,
      title: "Direct Sourcing",
      description: "We source materials directly from manufacturers, cutting out middlemen costs."
    },
    {
      icon: Truck,
      title: "Logistics",
      description: "Efficient supply chain management from our warehouse to your property."
    },
    {
      icon: Wrench,
      title: "Installation",
      description: "Experienced crews turning 3+ units per day with quality craftsmanship."
    },
    {
      icon: TrendingUp,
      title: "Value Creation",
      description: "27% cheaper than market with faster turnaround for better ROC."
    }
  ];

  return (
    <section 
      id="about" 
      className="section-padding bg-slate-50"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <span className="text-cyan-600 font-semibold text-sm tracking-widest uppercase mb-4 block">
              About Us
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-6">
              Vertically Integrated{" "}
              <span className="text-cyan-600">Contractor</span>
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              Unlike traditional contractors who rely on multiple sub-contractors and distributors, 
              Altura Source controls the entire process from factory to finish. Our vertically 
              integrated model means we source, manufacture, deliver, and install—all under one roof.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed mb-10">
              This approach eliminates markup layers, reduces coordination overhead, and ensures 
              consistent quality across all your properties. The result? Significant cost savings 
              and faster project completion for your multifamily investments.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="flex items-start gap-4"
                  data-testid={`about-feature-${index}`}
                >
                  <div className="w-12 h-12 bg-cyan-100 rounded-md flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-6 h-6 text-cyan-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-slate-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1755624222023-621f7718950b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBraXRjaGVufGVufDB8fHx8MTc3NTY3MTQwMHww&ixlib=rb-4.1.0&q=85"
                alt="Modern apartment kitchen renovation"
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            {/* Stats Overlay */}
            <div className="absolute -bottom-6 -left-6 bg-white shadow-xl rounded-lg p-6 border border-slate-100">
              <div className="text-3xl font-bold text-cyan-600 mb-1">10,000+</div>
              <div className="text-sm text-slate-600 font-medium">Units Renovated</div>
            </div>
            <div className="absolute -top-6 -right-6 bg-cyan-600 shadow-xl rounded-lg p-6">
              <div className="text-3xl font-bold text-white mb-1">15+</div>
              <div className="text-sm text-cyan-100 font-medium">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
